import { useEffect, useState, useContext } from 'react'

import emitter from 'garden/src/js/utils/emitter'

import CartDrawer from '../components/CartDrawer'
import { HeaderContext } from '../../../contexts/HeaderContext'

export default () => {
  const headerContext = useContext(HeaderContext)
  const { toggleCartDrawer } = headerContext
  const [informationCart, setInformationCart] = useState({
    shippings: [],
    uniqueProductsCount: 0,
    total: 0,
    subTotal: 0,
    discountTotal: 0,
    services: []
  })

  useEffect(() => {
    emitter.on('cart:products-added', (cart) => {
      setInformationCart(cart)
      toggleCartDrawer()
    })
  }, [toggleCartDrawer])

  return (
    <CartDrawer cart={informationCart} />
  )
}
